import { action, observable, makeObservable } from 'mobx';

import agent from '../agent';
import commonStore from './commonStore';

class UserGroupStore {
    constructor() {
        makeObservable(this, {
            userGroupMap: observable,
            getUserGroups: action,
            getGroupByUserAndUsageDetails: action,
            addOrUpdateUserGroupAndAssignees: action,
            removeUserGroup: action,
            getGroupDetails: action,
            getUsersInGroup: action,
        });
    }

    userGroupMap = null;

    getGroupDetails(params = {}) {
        try {
            return agent.UserGroups.getGroupDetails(params).then(
                action((response) => {
                    const list = response.userGroupList ? response.userGroupList : []
                    this.setUserGroupStore(list)
                    return list;
                })
            ).catch(
                action(err => {
                    throw err
                })
            )
        } catch (err) {
            commonStore.addNotification(err.message, null, 'error');
        }
    }

    setUserGroupStore(userGroups) {
        const userGroupMap = new Map();
        userGroups.forEach(ele => {
            if (ele?.code) {
                userGroupMap.set(ele.code, ele);
            }
        });
        this.userGroupMap = userGroupMap;
    }

    getUserGroup(id) {
        return this.userGroupMap?.get(id);
    }

    getUserGroups(user_id) {
        try {
            return agent.UserGroups.getUserGroups(user_id).then(
                action((response) => {
                    return response.userGroups ? response.userGroups : [];
                })
            ).catch(
                action(err => {
                    throw err
                })
            )
        } catch (err) {
            commonStore.addNotification(err.message, null, 'error');
        }
    }

    getGroupByUserAndUsageDetails() {
        try {
            return agent.UserGroups.getGroupByUserAndUsageDetails().then(
                action((response) => {
                    return response.user_groups_hash_map ? response.user_groups_hash_map : [];
                })
            ).catch(
                action(err => {
                    throw err
                })
            )
        } catch (err) {
            commonStore.addNotification(err.message, null, 'error');
        }
    }

    addOrUpdateUserGroupAndAssignees(data, isAdd) {
        try {
            if (isAdd) {
                return agent.UserGroups.addUserGroupAndAssignMembers(data).then(
                    action((response) => {
                        return response;
                    })
                ).catch(
                    action(err => {
                        throw err
                    })
                )
            } else {
                return agent.UserGroups.updateUserGroupAndAssignees(data).then(
                    action((response) => {
                        return response;
                    })
                ).catch(
                    action(err => {
                        throw err
                    })
                )
            }
        } catch (err) {
            commonStore.addNotification(err.message, null, 'error');
        }
    }

    removeUserGroup(code) {
        try {
            return agent.UserGroups.removeGroup(code).then(
                action((response) => {
                    return response;
                })
            ).catch(
                action(err => {
                    console.error("eee", err)
                    throw err
                })
            )
        } catch (err) {
            commonStore.addNotification(err.message, null, 'error');
        }
    }

    getUsersInGroup(code) {
        try {
            return agent.UserGroups.getUsersInGroup(code).then(
                action((response) => {
                    return response;
                })
            ).catch(
                action(err => {
                    throw err;
                })
            )
        } catch (err) {
            commonStore.addNotification(err.message, null, 'error');
        }
    }

}

const _UserGroupStore = new UserGroupStore()
export default _UserGroupStore;
